<template>
  <div>
    <Layout :pagetitle="$t('Campaigns')">
      <Table
        :title="$t('Campaigns')"
        :items="campaigns"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :searchable="true"
        :editable="true"
        :removable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editCampaign"
        @onCreate="createCampaign"
        @onRemove="onRemove"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'brand_name',
          label: this.$t('Brand')
        },
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'promocode',
          label: this.$t('Promo code')
        }
      ],
      campaigns: []
    };
  },
  mounted() {
    this.getCampaigns();
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getCampaigns();
    },
    onRemove(campaign) {
      this.$api.destroy(`api/campaign/${campaign.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('Campaign was excluded with success')
        });
        this.getCampaigns();
      });
    },
    getCampaigns() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/campaign', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.campaigns = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createCampaign() {
      this.$router.push({
        name: 'campaignCreate'
      });
    },
    editCampaign(campaign) {
      this.$router.push({
        name: 'campaignUpdate',
        params: {
          id: campaign.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getCampaigns();
    }
  }
};
</script>

<style></style>
